<template>
	<v-form
		v-model="isValid"
		@submit.prevent="submit"
	>
		<v-layout
			row
			wrap
			ma-0
			justify-center
			align-center
		>
			<v-flex
				xs12
				sm9
				py-0
			>
				<v-select
					:items="selectFilterModelType"
					v-model="filterModelType"
					:rules="[
						...validate.require
					]"
					label="When"
					autofocus
				/>
				<v-text-field
					v-model="filterModelId"
					:rules="[
						...validate.number
					]"
					label="Equals"
				/>
				<v-select
					:items="selectOverrideModelType"
					v-model="overrideModelType"
					:rules="[
						...validate.require
					]"
					label="Then Set"
				/>
				<v-text-field
					v-model="attribute"
					:rules="[
						...validate.require
					]"
					label="attribute"

				/>
				<v-text-field
					v-model="value"
					:rules="[
						...validate.require
					]"
					label="value"

				/>
			</v-flex>
			<v-flex
				xs12
				sm3
			>
				<v-btn
					:disabled="!isValid"
					ripple
					color="primary"
					type="submit"
				>
					Submit
				</v-btn>
				<v-btn
					flat
					color="error"
					@click="$emit('close')"
				>
					close
				</v-btn>
			</v-flex>
		</v-layout>
	</v-form>
</template>

<script>
import Validation from '@/mixins/Validation';
import { Override } from '@/models/Override';

export default {
	props: {
		editOverride: {
			type: Object,
			default: null,
		},
	},
	
	mixins: [Validation],
	
	data() {
		return {
			filterModelType: '',
			filterModelId: '',
			overrideModelType: '',
			attribute: '',
			value: '',
			//fieldTypes: CustomData.FIELD_TYPES,
			isValid: true,
			selectFilterModelType: [
				{ value: 'article', text: 'article'},
				{ value: 'category', text: 'category'},
				{ value: 'publication', text: 'publication'},
				{ value: 'client', text: 'project'},
			],
			selectOverrideModelType: [
				{ value: 'article', text: 'article'},
				{ value: 'category', text: 'category'},
				{ value: 'publication', text: 'publication'},
				{ value: 'report', text: 'report'},
				{ value: 'client', text: 'project'},
			],
		};
	},
	
	watch: {
		editOverride(override) {
			if (override) {
				this.filterModelType = override.filterModelType;
				this.filterModelId = override.filterModelId;
				this.overrideModelType = override.overrideModelType;
				this.attribute = override.attribute;
				this.value = override.value;
			}
		},
	},
	
	computed: {
		isEdit() {
			return Boolean(this.editOverride);
		},
		
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		Overrides() {
			return this.project.overrides;
		},
		
		overrideAttributes() {
			const options = this.$store.get('markdownOptions');
			
			console.log(options);
			
			return [
				{ value: 'article', text: 'article'},
				{ value: 'category', text: 'category'},
				{ value: 'publication', text: 'publication'},
				{ value: 'report', text: 'report'},
				{ value: 'client', text: 'project'},
			];
		},
	},
	
	methods: {
		submit() {
			this.isValid = false;
			this.isEdit ? this.update() : this.create();
		},

		update() {
			const m = new Override();
			m.id = this.editOverride.id;
			m.filterModelType = this.filterModelType;
			m.filterModelId = this.filterModelId;
			m.overrideModelType = this.overrideModelType;
			m.attribute = this.attribute;
			m.value = this.value;

			m.save().then(() => {
				this.$notify('success', `Override "${m.id}" has been updated.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to update override "${m.id}".`);
			}).finally(() => {
				this.refreshOverrides();
			});
		},

		create() {
			const m = new Override();
			m.set('projectId', this.project.id);
			m.filterModelType = this.filterModelType;
			m.filterModelId = this.filterModelId;
			m.overrideModelType = this.overrideModelType;
			m.attribute = this.attribute;
			m.value = this.value;

			m.save().then(() => {
				this.$notify('success', `Override "${m.id}" has been created.`);
			}).catch((e) => {
				dump(e);
				this.$notify('error', `Failed to create override "${m.id}".`);
			}).finally(() => {
				this.refreshOverrides();
			});
		},

		refreshOverrides() {
			this.$store.dispatch('projects/loadOverrides').then().catch((e) => {
				dump(e);
				this.$notify('error', `Failed to refresh overrides.`);
			}).finally(() => {
				this.isValid = true;
				this.$emit('close');
			});
		},
	},
}
</script>
